// Redesign palette — "Clean & Minimal" (mockups/redesign/components.html).
// Brand red carries meaning only; three ink levels; hairline borders.
const vuetifyColors = {
    primary: '#D32946',          // brand
    secondary: '#A31C35',        // brand-dark (hover/pressed)
    accent: '#1A1A1A',
    error: '#D32946',            // one red app-wide
    warning: '#DE870A',
    success: '#1E9E76',
    info: '#2477C8',
    white: '#ffffff',
    surface: '#FFFFFF',
    text: '#1A1A1A',             // ink
    charcoal: '#6B6B6B',         // ink-2
    textSubtle: '#9B9B9B',       // ink-3
    light: '#FAFAFA',            // page background
    borderLight: '#ECECEC',      // hairline
    border: '#D8D8D8',
    brandTint: '#FBEDF0',
    successTint: '#E7F6F1',
    warningTint: '#FCF3E4',
    facebook: '#4267B2',
    google: '#EA4335',
};
export default vuetifyColors;
